export default __webpack_public_path__ + "static/10_36-4f4c522e4b9dd704df162a8560cd2faf.png";